// Utility function to clear card data from DOM
export const clearCardData = async (): Promise<void> => {
  return new Promise((resolve) => {
    const cardNumberEl = document.getElementById('cardNumber');
    const expirationDateEl = document.getElementById('expirationDate');
    const cvvEl = document.getElementById('cvv');

    if (cardNumberEl) {
      cardNumberEl.innerHTML = '';
      cardNumberEl.removeAttribute('data-highnote-field');
    }
    if (expirationDateEl) {
      expirationDateEl.innerHTML = '';
      expirationDateEl.removeAttribute('data-highnote-field');
    }
    if (cvvEl) {
      cvvEl.innerHTML = '';
      cvvEl.removeAttribute('data-highnote-field');
    }

    resolve();
  });
};
